(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode("._arrowContainer_xqmcg_1{display:var(--json-tree-inline-flex);margin-right:var(--json-tree-arrow-container-margin-right)}._arrow_xqmcg_1{transition:var(--json-tree-arrow-transition);transform-origin:var(--json-tree-arrow-transform-origin);display:var(--json-tree-inline-flex);color:var(--json-tree-arrow-color);position:var(--json-tree-arrow-position);left:var(--json-tree-arrow-left-offset);margin-right:var(--json-tree-arrow-right-margin);top:0}._arrow--expanded_xqmcg_16{transform:var(--json-tree-arrow-transform)}._arrowInner_xqmcg_19{position:var(--json-tree-arrow-position);left:calc(var(--json-tree-arrow-width) / 3 * -1)}._itemRange_ed7dq_1{position:relative;display:var(--json-tree-inline)}._nestedNode_j6j98_1{display:var(--json-tree-inline-flex);position:relative;cursor:default}._nestedNode--expandable_j6j98_6{align-items:var(--json-tree-align-items);display:var(--json-tree-block);cursor:pointer}._nestedNode--expanded_j6j98_11{display:var(--json-tree-inline)}._nestedNode--itemType_j6j98_14{margin-right:var(--json-tree-nested-node-item-type-margin)}._nestedNode--itemType--expanded_j6j98_17{display:var(--json-tree-inline)}._nestedNodeLabelWrap_j6j98_21{display:var(--json-tree-block);align-items:var(--json-tree-align-items)}._nestedNodeItemString_j6j98_26{display:var(--json-tree-inline-flex)}._nestedNodeChildren_j6j98_30{display:var(--json-tree-block);flex-direction:var(--json-tree-flex-direction);margin-left:var(--json-tree-children-margin);padding:var(--json-tree-ul-padding)}._nestedNodeLabel_j6j98_21{display:var(--json-tree-inline-flex);align-items:var(--json-tree-align-items);margin-right:var(--json-tree-nested-node-label-margin);cursor:default}._nestedNodeLabel--expandable_j6j98_43{display:var(--json-tree-inline-flex);align-items:var(--json-tree-align-items);cursor:pointer}._nestedNodeLabel--expanded_j6j98_48{display:var(--json-tree-inline-flex)}._rootNode_j6j98_52{display:var(--json-tree-inline-flex);cursor:default}._rootNodeExpandable_j6j98_57{cursor:pointer}._rootNodeChildren_j6j98_61{display:var(--json-tree-block);flex-direction:var(--json-tree-flex-direction);padding:var(--json-tree-ul-root-children-padding)}._nodeListItemScrolled_18ya2_1{scroll-margin:var(--json-tree-scroll-margin)}._valueNode_1b1pr_1{display:var(--json-tree-block);align-items:var(--json-tree-value-node-align-items);cursor:default}._valueNodeValue_1b1pr_7{text-wrap:var(--json-tree-value-text-wrap);word-break:var(--json-tree-value-text-word-break);color:var(--json-tree-label-value-color)}._valueNodeLabel_1b1pr_13{margin-right:var(--json-tree-value-label-margin);display:var(--json-tree-inline-flex)}._valueNodeScrolled_1b1pr_18{scroll-margin:var(--json-tree-scroll-margin)}:root{--json-tree-spacing-sm: .25em;--json-tree-spacing-md: .5em;--json-tree-spacing-lg: 1em;--json-tree-spacing-xl: 1.5em;--json-tree-spacing-xxl: 2em;--json-tree-children-margin: var(--json-tree-spacing-xl);--json-tree-value-label-margin: var(--json-tree-spacing-sm);--json-tree-value-node-margin: var(--json-tree-spacing-xl);--json-tree-nested-node-label-margin: var(--json-tree-spacing-md);--json-tree-nested-node-item-type-margin: var(--json-tree-spacing-sm);--json-tree-default-label-wrap-margin-right: var(--json-tree-spacing-md);--json-tree-arrow-container-margin-right: 0;--json-tree-ul-root-padding: 0 0 0 var(--json-tree-spacing-xxl);--json-tree-ul-root-children-padding: 0;--json-tree-ul-padding: 0;--json-tree-value-text-wrap: wrap;--json-tree-value-text-word-break: break-word;--json-tree-inline: inline-grid;--json-tree-inline-flex: inline-flex;--json-tree-block: flex;--json-tree-align-items: center;--json-tree-value-node-align-items: flex-start;--json-tree-flex-direction: column;--json-tree-arrow-transition: var(--json-tree-transition-timing) linear transform;--json-tree-arrow-transform-origin: 45% 50%;--json-tree-arrow-transform: rotateZ(90deg);--json-tree-arrow-width: 1.5em;--json-tree-arrow-height: 1.5em;--json-tree-arrow-position: absolute;--json-tree-arrow-left-offset: calc(var(--json-tree-arrow-width) * -1);--json-tree-arrow-right-margin: 0;--json-tree-label-color: rgb(102, 217, 239);--json-tree-key-label-color: rgb(71, 131, 0);--json-tree-label-value-color: rgb(249, 38, 114);--json-tree-arrow-color: var(--json-tree-label-color);--json-tree-transition-timing: .15s;--json-tree-scroll-margin: 0}._tree_ze97d_48{padding:var(--json-tree-ul-root-padding)}._defaultItemString_ze97d_52{display:var(--json-tree-inline-flex);color:var(--json-tree-key-label-color)}._defaultLabelWrap_ze97d_57{display:var(--json-tree-inline-flex);margin-right:var(--json-tree-default-label-wrap-margin-right);color:var(--json-tree-label-color);cursor:default}._defaultLabelWrap--expandable_ze97d_63{cursor:pointer}")),document.head.appendChild(e)}}catch(r){console.error("vite-plugin-css-injected-by-js",r)}})();
import { jsxs as g, jsx as c } from "react/jsx-runtime";
import S, { useState as M, useCallback as J, createElement as k } from "react";
function K(e) {
  const t = Object.prototype.toString.call(e).slice(8, -1);
  return t === "Object" && typeof e[Symbol.iterator] == "function" ? "Iterable" : t === "Custom" && e.constructor !== Object && e instanceof Object ? "Object" : t;
}
const U = "_arrow_xqmcg_1", H = "_arrow--expanded_xqmcg_16", Q = "_arrowInner_xqmcg_19", x = {
  arrow: U,
  arrowExpanded: H,
  arrowInner: Q
};
function P({
  arrowStyle: e = "single",
  expanded: t,
  onClick: n
}) {
  return /* @__PURE__ */ g(
    "div",
    {
      role: "button",
      "aria-expanded": t,
      tabIndex: 0,
      onClick: n,
      onKeyDown: (a) => {
        (a.key === "Enter" || a.key === " ") && (a.preventDefault(), n());
      },
      className: `${x.arrow} ${t ? x.arrowExpanded : ""} ${e === "single" ? x.arrowArrowStyleSingle : x.arrowArrowStyleDouble}`,
      children: [
        "▶",
        e === "double" && /* @__PURE__ */ c("div", { className: `${x.arrowInner}`, children: "▶" })
      ]
    }
  );
}
function X(e, t) {
  return e === "Object" ? Object.keys(t).length : e === "Array" ? t.length : 1 / 0;
}
function Y(e) {
  return typeof e.set == "function";
}
function Z(e, t, n, a = 0, r = 1 / 0) {
  let s;
  if (e === "Object") {
    let d = Object.getOwnPropertyNames(t);
    n && d.sort(n === !0 ? void 0 : n), d = d.slice(a, r + 1), s = {
      entries: d.map((l) => ({ key: l, value: t[l] }))
    };
  } else if (e === "Array")
    s = {
      entries: t.slice(a, r + 1).map((d, l) => ({ key: l + a, value: d }))
    };
  else {
    let d = 0;
    const l = [];
    let i = !0;
    const N = Y(t);
    for (const o of t) {
      if (d > r) {
        i = !1;
        break;
      }
      a <= d && (N && Array.isArray(o) ? typeof o[0] == "string" || typeof o[0] == "number" ? l.push({ key: o[0], value: o[1] }) : l.push({
        key: `[entry ${d}]`,
        value: {
          "[key]": o[0],
          "[value]": o[1]
        }
      }) : l.push({ key: d, value: o })), d++;
    }
    s = {
      hasMore: !i,
      entries: l
    };
  }
  return s;
}
function L(e, t, n) {
  const a = [];
  for (; t - e > n * n; )
    n = n * n;
  for (let r = e; r <= t; r += n)
    a.push({ from: r, to: Math.min(t, r + n - 1) });
  return a;
}
function ee(e, t, n, a, r = 0, s = 1 / 0) {
  const d = Z.bind(
    null,
    e,
    t,
    n
  );
  if (!a)
    return d().entries;
  const l = s < 1 / 0, i = Math.min(s - r, X(e, t));
  if (e !== "Iterable") {
    if (i <= a || a < 7)
      return d(r, s).entries;
  } else if (i <= a && !l)
    return d(r, s).entries;
  let N;
  if (e === "Iterable") {
    const { hasMore: o, entries: u } = d(r, r + a - 1);
    N = o ? [...u, ...L(r + a, r + 2 * a - 1, a)] : u;
  } else
    N = l ? L(r, s, a) : [
      ...d(0, a - 5).entries,
      ...L(a - 4, i - 5, a),
      ...d(i - 4, i - 1).entries
    ];
  return N;
}
const te = "_itemRange_ed7dq_1", R = {
  itemRange: te
};
function ne(e) {
  const { from: t, to: n, renderChildNodes: a, nodeType: r, scrollToPath: s, keyPath: d } = e;
  let l = !1;
  if (s) {
    const [u] = s;
    C(s.slice(d.length * -1), d) && u > t && u <= n && (l = !0);
  }
  const [i, N] = M(l), o = J(() => {
    N(!i);
  }, [i]);
  return i ? /* @__PURE__ */ c("div", { className: `${R.itemRange}`, children: a(e, t, n) }) : /* @__PURE__ */ g("div", { className: `${R.itemRange}`, children: [
    /* @__PURE__ */ c(
      P,
      {
        nodeType: r,
        expanded: !1,
        onClick: o,
        arrowStyle: "double"
      }
    ),
    `${t} ... ${n}`
  ] });
}
const ae = "_nestedNode_j6j98_1", re = "_nestedNode--expandable_j6j98_6", oe = "_nestedNode--expanded_j6j98_11", de = "_nestedNode--itemType_j6j98_14", se = "_nestedNode--itemType--expanded_j6j98_17", le = "_nestedNodeLabelWrap_j6j98_21", ce = "_nestedNodeItemString_j6j98_26", ie = "_nestedNodeChildren_j6j98_30", ue = "_nestedNodeLabel_j6j98_21", Ne = "_nestedNodeLabel--expandable_j6j98_43", pe = "_nestedNodeLabel--expanded_j6j98_48", fe = "_rootNode_j6j98_52", be = "_rootNodeExpandable_j6j98_57", _e = "_rootNodeChildren_j6j98_61", b = {
  nestedNode: ae,
  nestedNodeExpandable: re,
  nestedNodeExpanded: oe,
  nestedNodeItemType: de,
  nestedNodeItemTypeExpanded: se,
  nestedNodeLabelWrap: le,
  nestedNodeItemString: ce,
  nestedNodeChildren: ie,
  nestedNodeLabel: ue,
  nestedNodeLabelExpandable: Ne,
  nestedNodeLabelExpanded: pe,
  rootNode: fe,
  rootNodeExpandable: be,
  rootNodeChildren: _e
}, he = "_nodeListItemScrolled_18ya2_1", ye = {
  nodeListItemScrolled: he
}, W = ({
  children: e,
  expanded: t,
  expandable: n,
  nodeType: a,
  keyPath: r,
  className: s,
  scrollToPath: d
}) => {
  var o, u;
  const l = S.useRef(null), i = d !== void 0 && C(d, r);
  S.useEffect(() => {
    l.current && l.current.scrollIntoView({ behavior: "auto" });
  }, []);
  const N = i ? { ref: l, "data-scrolled": "true" } : {};
  return n ? /* @__PURE__ */ c(
    "li",
    {
      role: "treeitem",
      "aria-expanded": t,
      "data-nodetype": a,
      "data-keypath": r[0],
      "aria-label": (o = r[0]) == null ? void 0 : o.toString(),
      className: `${s} ${i ? ye.nodeListItemScrolled : ""}`,
      ...N,
      children: e
    }
  ) : /* @__PURE__ */ c(
    "li",
    {
      role: "treeitem",
      "data-nodetype": a,
      "data-keypath": r[0],
      "aria-label": (u = r[0]) == null ? void 0 : u.toString(),
      className: s,
      ...N,
      children: e
    }
  );
};
function ge(e) {
  return e.to !== void 0;
}
function V(e, t, n) {
  const {
    nodeType: a,
    data: r,
    collectionLimit: s,
    circularCache: d,
    keyPath: l,
    postprocessValue: i,
    sortObjectKeys: N,
    scrollToPath: o
  } = e, u = [];
  return ee(
    a,
    r,
    N,
    s,
    t,
    n
  ).forEach((f) => {
    if (ge(f))
      u.push(
        /* @__PURE__ */ k(
          ne,
          {
            ...e,
            key: `ItemRange--${f.from}-${f.to}`,
            from: f.from,
            to: f.to,
            renderChildNodes: V,
            scrollToPath: o
          }
        )
      );
    else {
      const { key: p, value: m } = f, E = d.includes(m);
      u.push(
        /* @__PURE__ */ k(
          z,
          {
            ...e,
            postprocessValue: i,
            collectionLimit: s,
            key: `Node--${p}`,
            keyPath: [p, ...l],
            value: i(m),
            circularCache: [...d, m],
            isCircular: E,
            hideRoot: !1
          }
        )
      );
    }
  }), u;
}
function w(e) {
  const {
    circularCache: t = [],
    collectionLimit: n,
    createItemString: a,
    data: r,
    expandable: s,
    getItemString: d,
    hideRoot: l,
    hideRootExpand: i,
    isCircular: N,
    keyPath: o,
    labelRenderer: u,
    level: f = 0,
    nodeType: p,
    nodeTypeIndicator: m,
    shouldExpandNodeInitially: E,
    scrollToPath: O
  } = e, G = o[0] === "root", T = i ? s && !G && i : s, y = s && T, [_, q] = M(
    // calculate individual node expansion if necessary
    N ? !1 : E(o, r, f)
  ), j = J(() => {
    y && q(!_);
  }, [y, _]), v = _ || l && f === 0 ? V({ ...e, circularCache: t, level: f + 1 }) : null, D = /* @__PURE__ */ c(
    "span",
    {
      className: `${b.nestedNodeItemType} ${_ ? b.nestedNodeItemTypeExpanded : ""}`,
      children: m
    }
  ), B = d(
    p,
    r,
    D,
    a(r, n),
    o
  ), F = [o, p, _, y];
  return l ? /* @__PURE__ */ c(
    W,
    {
      scrollToPath: O,
      expandable: y,
      expanded: _,
      nodeType: p,
      keyPath: o,
      className: `${b.rootNode} ${_ ? b.rootNodeExpanded : ""} ${s ? b.rootNodeExpandable : ""}`,
      children: /* @__PURE__ */ c("ul", { className: `${b.rootNodeChildren}`, children: v })
    }
  ) : /* @__PURE__ */ g(
    W,
    {
      scrollToPath: O,
      expandable: y,
      expanded: _,
      nodeType: p,
      keyPath: o,
      className: `${b.nestedNode}  ${_ ? b.nestedNodeExpanded : ""} ${y ? b.nestedNodeExpandable : ""}`,
      children: [
        /* @__PURE__ */ g("span", { className: b.nestedNodeLabelWrap, children: [
          T && /* @__PURE__ */ c(
            P,
            {
              nodeType: p,
              expanded: _,
              onClick: j
            }
          ),
          /* @__PURE__ */ c(
            "span",
            {
              "data-nodetype": p,
              "data-keypath": o[0],
              className: `${b.nestedNodeLabel} ${_ ? b.nestedNodeLabelExpanded : ""} ${y ? b.nestedNodeLabelExpandable : ""}`,
              onClick: j,
              children: u(...F)
            }
          ),
          /* @__PURE__ */ c("span", { className: b.nestedNodeItemString, onClick: j, children: B })
        ] }),
        v && /* @__PURE__ */ c("ul", { className: b.nestedNodeChildren, children: v })
      ]
    }
  );
}
function me(e) {
  const t = Object.getOwnPropertyNames(e).length;
  return `${t} ${t !== 1 ? "keys" : "key"}`;
}
function xe({ data: e, ...t }) {
  return /* @__PURE__ */ c(
    w,
    {
      ...t,
      data: e,
      nodeType: "Object",
      nodeTypeIndicator: t.nodeType === "Error" ? "Error()" : "{}",
      createItemString: me,
      expandable: Object.getOwnPropertyNames(e).length > 0
    }
  );
}
function Ie(e) {
  return `${e.length} ${e.length !== 1 ? "items" : "item"}`;
}
function Se({ data: e, ...t }) {
  return /* @__PURE__ */ c(
    w,
    {
      ...t,
      data: e,
      nodeType: "Array",
      nodeTypeIndicator: "[]",
      createItemString: Ie,
      expandable: e.length > 0
    }
  );
}
function $e(e, t) {
  let n = 0, a = !1;
  if (Number.isSafeInteger(e.size))
    n = e.size;
  else
    for (const r of e) {
      if (t && n + 1 > t) {
        a = !0;
        break;
      }
      n += 1;
    }
  return `${a ? ">" : ""}${n} ${n !== 1 ? "entries" : "entry"}`;
}
function Ee(e) {
  return /* @__PURE__ */ c(
    w,
    {
      ...e,
      nodeType: "Iterable",
      nodeTypeIndicator: "()",
      createItemString: $e,
      expandable: !0
    }
  );
}
const je = "_valueNode_1b1pr_1", ve = "_valueNodeValue_1b1pr_7", Le = "_valueNodeLabel_1b1pr_13", ke = "_valueNodeScrolled_1b1pr_18", I = {
  valueNode: je,
  valueNodeValue: ve,
  valueNodeLabel: Le,
  valueNodeScrolled: ke
};
function h({
  nodeType: e,
  labelRenderer: t,
  keyPath: n,
  valueRenderer: a,
  value: r,
  valueGetter: s = (l) => l,
  scrollToPath: d
}) {
  const l = S.useRef(null), i = d !== void 0 && C(d, n);
  S.useEffect(() => {
    l.current && l.current.scrollIntoView({ behavior: "auto" });
  }, []);
  const N = i ? { ref: l, "data-scrolled": "true" } : {};
  return /* @__PURE__ */ g(
    "li",
    {
      className: `${I.valueNode} valueNode--${e} valueNode--${n[0]} ${i ? I.valueNodeScrolled : ""}`,
      ...N,
      children: [
        /* @__PURE__ */ c("span", { className: I.valueNodeLabel, children: t(n, e, !1, !1) }),
        /* @__PURE__ */ c("span", { className: I.valueNodeValue, children: a(
          s ? s(r) : void 0,
          r,
          ...n
        ) })
      ]
    }
  );
}
function z({
  getItemString: e,
  keyPath: t,
  labelRenderer: n,
  value: a,
  valueRenderer: r,
  isCustomNode: s,
  valueWrap: d,
  scrollToPath: l,
  ...i
}) {
  const N = s(a) ? "Custom" : K(a), o = t[0], u = {
    keyPath: t,
    labelRenderer: n,
    nodeType: N,
    value: a,
    valueRenderer: r,
    scrollToPath: l
  }, f = {
    ...i,
    ...u,
    getItemString: e,
    data: a,
    isCustomNode: s,
    valueWrap: d
  };
  switch (N) {
    case "Object":
    case "Error":
    case "WeakMap":
    case "WeakSet":
      return /* @__PURE__ */ c(xe, { ...f }, o);
    case "Array":
      return /* @__PURE__ */ c(Se, { ...f }, o);
    case "Iterable":
    case "Map":
    case "Set":
      return /* @__PURE__ */ c(Ee, { ...f }, o);
    case "String":
      return /* @__PURE__ */ k(
        h,
        {
          ...u,
          key: o,
          valueGetter: (p) => `${d}${p}${d}`
        }
      );
    case "Number":
      return /* @__PURE__ */ c(h, { ...u }, o);
    case "Boolean":
      return /* @__PURE__ */ c(
        h,
        {
          ...u,
          valueGetter: (p) => p ? "true" : "false"
        },
        o
      );
    case "Date":
      return /* @__PURE__ */ c(
        h,
        {
          ...u,
          valueGetter: (p) => p.toISOString()
        },
        o
      );
    case "Null":
      return /* @__PURE__ */ c(
        h,
        {
          ...u,
          valueGetter: () => "null"
        },
        o
      );
    case "Undefined":
      return /* @__PURE__ */ c(
        h,
        {
          ...u,
          valueGetter: () => "undefined"
        },
        o
      );
    case "Function":
    case "Symbol":
      return /* @__PURE__ */ c(
        h,
        {
          ...u,
          valueGetter: (p) => p.toString()
        },
        o
      );
    case "Custom":
      return /* @__PURE__ */ c(h, { ...u }, o);
    default:
      return /* @__PURE__ */ c(
        h,
        {
          ...u,
          valueGetter: () => `<${N}>`
        },
        o
      );
  }
}
const we = "_tree_ze97d_48", Ce = "_defaultItemString_ze97d_52", Oe = "_defaultLabelWrap_ze97d_57", Te = "_defaultLabelWrap--expandable_ze97d_63", $ = {
  tree: we,
  defaultItemString: Ce,
  defaultLabelWrap: Oe,
  defaultLabelWrapExpandable: Te
}, A = (e) => e, Re = (e, t, n) => n === 0, We = (e, t, n, a, r) => /* @__PURE__ */ g("span", { className: $.defaultItemString, children: [
  n,
  " ",
  a
] }), Ae = ([e], t, n, a) => /* @__PURE__ */ g(
  "span",
  {
    className: `${$.defaultLabelWrap} ${a ? $.defaultLabelWrapExpandable : ""}`,
    children: [
      e,
      ":"
    ]
  }
), Me = () => !1;
function Ve({
  data: e,
  keyPath: t = ["root"],
  labelRenderer: n = Ae,
  valueRenderer: a = A,
  shouldExpandNodeInitially: r = Re,
  hideRoot: s = !1,
  hideRootExpand: d = !1,
  getItemString: l = We,
  postprocessValue: i = A,
  isCustomNode: N = Me,
  collectionLimit: o = 50,
  sortObjectKeys: u = !1,
  scrollToPath: f,
  valueWrap: p = '"'
}) {
  return /* @__PURE__ */ c(
    "ul",
    {
      role: "tree",
      "aria-multiselectable": !0,
      "aria-readonly": "true",
      className: $.tree,
      children: /* @__PURE__ */ c(
        z,
        {
          scrollToPath: f,
          hideRootExpand: d,
          keyPath: s ? [] : t,
          value: i(e),
          isCustomNode: N,
          labelRenderer: n,
          valueRenderer: a,
          shouldExpandNodeInitially: r,
          hideRoot: s,
          getItemString: l,
          postprocessValue: i,
          collectionLimit: o,
          sortObjectKeys: u,
          valueWrap: p
        }
      )
    }
  );
}
const C = (e, t) => {
  if (!e.length || e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
};
export {
  Ve as JSONTree,
  C as areKeyPathsEqual
};
